module.exports = __webpack_public_path__ + "img/selfAdhesive4.cbb352c7.jpg";